import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Input, Output } from '@angular/core';

@Component({
  selector: 'app-select',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
})
export class SelectComponent {
  selectedItem: string = '';
  @Input() label = '';
  @Input() items: any = [];
  @Input() value = '';
  @Input() title = '';
  @Input() error = '';
   @Output() selectedValue = new EventEmitter<any>();
   ngOnInit() {
    if (this.items.includes(this.value)) {
      this.selectedItem = this.value;
    }
  }

   setItem = (item: string) => {
    this.selectedItem = item;
    if (!this.title) {
      this.selectedValue.emit(item);
    } else {
      this.selectedValue.emit({ title: this.title, value: item });
    }
  };
}
